<template>
    <LoadingVue v-if="isLoading" />
    <div class="events" v-else>
        <TitleCommon title="lotto daily" :isShowButtonBack="true" />
        <NumberComponent :dataSource="dataSource" :markets="markets"/>
    </div>
</template>
<script>
import LottoService from '@/services/loto/loto.service';
import languageMixins from '@/mixins/language-mixins';
import LoadingVue from '@/components/common/loading/loading.vue';
import TitleCommon from '@/components/common/title/index.vue';
import NumberComponent from '@/components/loto/daily-lotto/number.vue';

import { mapState } from 'vuex';
import { isArrayEmpty } from '@/utils/utils';

export default {
    mixins: [languageMixins],
    components: { TitleCommon, NumberComponent, LoadingVue },
    data() {
        return {
            isLoading: true,
            dataSource: [],
            markets: []
        };
    },
    created() {
        this.fetchData();
    },
    computed: {
        ...mapState(['ModulesDailyLotto']),
    },
    methods: {
        async fetchData() {
            try {
                if (isArrayEmpty(this.ModulesDailyLotto.draws)) {
                    const query = this.$route.query;
                    this.$router.push({ path: '/lotto-fixed-daily-lotto', query });
                }

                this.dataSource = this.ModulesDailyLotto.draws;
                this.markets = this.ModulesDailyLotto.markets

            } catch (error) {
                console.log(error);
            } finally {
                this.isLoading = false;
            }
        },
    },
};
</script>

<style lang="scss">
@import '@/public/scss/loto/events.scss';
</style>
